/**
 * Calculates the 2d distance between p1 and p2
 */
export function distance(p1: Point2D, p2: Point2D): number {
  const dX = p2.x - p1.x;
  const dY = p2.y - p1.y;
  return Math.sqrt(dX * dX + dY * dY);
}
